"use client";
import Link from "next/link";
import { Stack } from "@chakra-ui/react";
import BgImage from "public/shared/dottedGradientBg.svg";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text, Button } from "@/elements";
import { ListWithLabel, ListWithLabelProps } from "../list";

type CardProps = {
  button?: { label: string; link: string };
  description?: string[];
  extraContent?: string;
  features?: ListWithLabelProps["points"];
  pointsSpacing?: number;
  title?: string;
};

const CtaCard = (props: CardProps) => {
  const { button, description, extraContent, features, title, pointsSpacing = 2 } = props;
  const HeadingVariant = useHeadingVariant();
  const textVariant = useTextVariant();
  return (
    <Stack
      backgroundColor="primary.200"
      bgImage={`url(${BgImage.src})`}
      backgroundPosition={"center"}
      backgroundSize={"cover"}
      backgroundRepeat="no-repeat"
      color="white"
      gap={8}
      p={{ base: 6, md: 12 }}
      borderRadius={"8px"}
    >
      <Stack gap={4}>
        <Heading as="h2" variant={HeadingVariant} textAlign={"center"}>
          {title}
        </Heading>
        {description && (
          <Stack gap={1}>
            {description.map((desc, index) => (
              <Text key={index} variant={textVariant}>
                {desc}
              </Text>
            ))}
          </Stack>
        )}
        {features && (
          <ListWithLabel
            points={features}
            separator="–"
            textColor="white"
            spacing={pointsSpacing}
          />
        )}
      </Stack>
      {extraContent && (
        <Text variant={textVariant} color="white">
          {extraContent}
        </Text>
      )}
      {button && (
        <Button
          as={Link}
          variant={"secondary"}
          href={button.link}
          width={"fit-content"}
          whiteSpace="normal"
        >
          {button.label}
        </Button>
      )}
    </Stack>
  );
};

export default CtaCard;
